// extracted by mini-css-extract-plugin
export default {"link":"pM-z","disabled":"qM-z"};